var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"main-nav__submenu-item"},[_c('a',{staticClass:"main-nav__submenu-link",attrs:{"href":_vm.item.url}},[_c('span',{staticClass:"main-nav__submenu-link-text"},[_vm._v(_vm._s(_vm.item.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }